
import base from "./base/index"
import button from "./button/index"
import download from "./download/index"
import label from "./label/index"
import lang from "./lang/index"
import placeholder from "./placeholder/index"
import prompt from "./prompt/index"
import signIn from "./signIn/index"
import title from "./title/index"

export default {
    base,
    button,
    download,
    label,
    lang,
    placeholder,
    prompt,
    signIn,
    title
}